// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"bd9501b2","526":"ca672687","740":"54cc030e","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};